const addUserAgent = (req, pathValues) => {
  if (!req || !req.headers || !req.headers['user-agent']) return; // ideally log here but having issue importing lc-logger
  Array.isArray(pathValues) && pathValues.push({ path: 'deviceProfile.userAgent', value: req.headers['user-agent'] });
};

export default addUserAgent;

